import React, { useState, useEffect, useContext } from "react";
import { useParams, NavLink, useHistory, Link } from "react-router-dom";
import { AppLoad } from "../../../core/AppLoad";
import { AppConfig, AppStateContext } from "../../../app-state";
import { useForm } from "react-hook-form";
import { SubmitButton } from "../../../core/SubmitButton";
import { FormFile } from "./FormFile";
import { Spinner } from "../../../core/Spinner";
import 'moment/locale/cs';
import { getEventUrl } from "../../common/event/EventHelper";
import { EventAttendees } from "./EventAttendees";
import { Icon } from "../../../core/Icon";
import { EventEditGeneralFields } from "./EventEditGeneralFields";
export const EventEdit = () => {
    const { state, dispatch } = useContext(AppStateContext);
    const [submitErrors, setSubmitErrors] = useState([]);
    const { register, handleSubmit, errors, setValue } = useForm();
    const [loadState, setLoadState] = useState('loadingEdit'); //idle | loadingEdit | submitting
    const [percentage, setPercentage] = useState(null);
    const [general, setGeneral] = useState({ publish: "1", prolongation_time: 300 });
    const [images, setImages] = useState({ list: [] });
    const [docs, setDocs] = useState({ list: [] });
    const [attendees, setAttendees] = useState(null);
    const history = useHistory();
    const { urlEventId } = useParams();
    const updatePercentage = (event) => {
        if (event.lengthComputable) {
            var percent = Math.round((event.loaded / event.total) * 100);
            if (percent < 100)
                setPercentage(percent);
        }
        else {
            setPercentage(null);
        }
    };
    const onSubmit = (data) => {
        if (loadState == 'submitting')
            return;
        setSubmitErrors([]);
        setLoadState('submitting');
        data.editId = urlEventId;
        data.start = general.start;
        data.end = general.end;
        data.description = general.description;
        data.prolongation_time = general.prolongation_time;
        var fileCount = 0;
        data.mainImage = images.mainImage;
        for (let i = 0; i < images.list.length; i++) {
            let image = images.list[i];
            data['fileDOM-' + fileCount] = image.fileDOM;
            data['fileStatus-' + fileCount] = image.status;
            data['fileName-' + fileCount] = image.name;
            data['fileId-' + fileCount] = image.id;
            data['fileType-' + fileCount] = 'image';
            data['fileThumb-' + fileCount] = image.path_thumb;
            fileCount++;
        }
        for (let i = 0; i < docs.list.length; i++) {
            let doc = docs.list[i];
            data['fileDOM-' + fileCount] = doc.fileDOM;
            data['fileStatus-' + fileCount] = doc.status;
            data['fileName-' + fileCount] = doc.name;
            data['fileId-' + fileCount] = doc.id;
            data['fileType-' + fileCount] = 'doc';
            fileCount++;
        }
        data.fileCount = fileCount;
        AppLoad(AppConfig.APIUrl + 'admin/event-management/save', data, (event) => updatePercentage(event)).then((Response) => {
            if (Response.status == 'error') {
                setSubmitErrors(Response.errors);
            }
            else if (Response.status == 'ok') {
                setLoadState('saved');
                if (Response.newId) {
                    history.push(`/cs/proces/editovat-aukci/${Response.newId}`);
                }
                else {
                    dispatch({ type: 'appReload' });
                }
            }
        });
    };
    const loadEditData = () => {
        setLoadState('loadingEdit');
        AppLoad(AppConfig.APIUrl + 'admin/event-management/detail', { eventId: urlEventId }).then((Response) => {
            if (Response.status == 'error') {
                setSubmitErrors(Response.errors);
            }
            else if (Response.status == 'ok') {
                setImages(Response.imageData);
                setDocs(Response.docData);
                setGeneral(Response.data);
                setAttendees(Response.attendees);
                setLoadState('idle');
            }
        });
    };
    useEffect(() => {
        if (urlEventId)
            loadEditData();
        else
            setLoadState('idle');
    }, []);
    if (loadState == 'loadingEdit')
        return React.createElement(Spinner, { large: true });
    return (React.createElement("div", { className: "event-edit-key" },
        urlEventId && React.createElement("div", { className: "navbar" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "navbar-inner" },
                    React.createElement(NavLink, { to: getEventUrl(general), className: "back-link" },
                        React.createElement("span", { className: "icon", "aria-hidden": true }),
                        React.createElement("span", { className: "text" }, "Zp\u011Bt detail aukce"))))),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "emf-hd" }, urlEventId ?
                React.createElement(React.Fragment, null,
                    React.createElement("h1", { className: "emf-title" }, general.title),
                    React.createElement(Link, { to: `/cs/proces/odebrat-aukci/${urlEventId}`, className: "emf-remove" },
                        "Odebrat aukci",
                        React.createElement(Icon, { c: ['bin', 14, 14] })))
                :
                    React.createElement("h1", { className: "emf-title" }, "Nov\u00E1 aukce")),
            urlEventId && React.createElement(EventAttendees, { attendees: attendees, setAttendees: setAttendees })),
        general.status == 'cancelled' ? React.createElement("div", { className: "container" }, "Aukce zru\u0161ena")
            :
                React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "event-management-form" },
                            React.createElement("div", { className: "emf-top" },
                                React.createElement("div", { className: "emf-details" },
                                    React.createElement("div", { className: "emf-detail-fields" },
                                        React.createElement("h2", { className: "emf-heading" }, "Detaily aukce"),
                                        React.createElement(EventEditGeneralFields, { loadState: loadState, setLoadState: setLoadState, errors: errors, register: register, general: general, setGeneral: setGeneral }))),
                                React.createElement("div", { className: "emf-sub-info" },
                                    React.createElement("div", { className: "emf-imagery" },
                                        React.createElement("h2", { className: "emf-heading" }, "P\u0159ilo\u017Een\u00E9 obrazov\u00E9 materi\u00E1ly"),
                                        React.createElement(FormFile, { data: images, setData: (o) => setImages(o), allowMultiple: true, allowMainImage: true })),
                                    React.createElement("div", { className: "emf-docs" },
                                        React.createElement("h2", { className: "emf-heading" }, "P\u0159ilo\u017Een\u00E9 dokumenty"),
                                        React.createElement(FormFile, { data: docs, setData: (o) => setDocs(o), allowMultiple: true, allowMainImage: false })))),
                            React.createElement("div", { className: "emf-bottom" },
                                React.createElement("div", { className: "text-right" },
                                    React.createElement(SubmitButton, { label: urlEventId ? "Uložit" : "Pokračovat", percentage: percentage, loadState: loadState }))))))));
};
